import React from 'react';
import { Image } from 'react-bootstrap';
import ConsultationImg from '../Images/Banner1.png';
import './Nutrition.css';

function Consultation() {
  return (
    <div className="bg-page">
      <Image src={ConsultationImg} fluid className="Banner-Img" />

      <div className="form-section">
        <div className="form-wrapper">            
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSc6eHQUnu8NfzJNXFzQPP4uHhdjw64yV__4asTpaLhy5J7EAQ/viewform?embedded=true"
            className="google-form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Nutrition Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default Consultation;